import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Activate the non-blocking Google Fonts stylesheet. The CSS was already
// downloaded by the preload hint, so this switch is instant — no render block.
const gf = document.getElementById("google-fonts") as HTMLLinkElement | null;
if (gf) gf.media = "all";

// Inject analytics (umami) only when the endpoint env var is present.
// Avoids 502 console errors when the variable is unset in Railway.
const analyticsEndpoint = import.meta.env.VITE_ANALYTICS_ENDPOINT as string | undefined;
const analyticsWebsiteId = import.meta.env.VITE_ANALYTICS_WEBSITE_ID as string | undefined;
if (analyticsEndpoint?.startsWith("http") && analyticsWebsiteId) {
  const pc = document.createElement("link");
  pc.rel = "preconnect";
  pc.href = analyticsEndpoint;
  document.head.appendChild(pc);

  const s = document.createElement("script");
  s.defer = true;
  s.src = `${analyticsEndpoint}/umami`;
  s.dataset.websiteId = analyticsWebsiteId;
  document.head.appendChild(s);
}

// Prerendered routes ship real markup inside #root — hydrate it (reuses the
// server HTML, no flash, no re-paint). The 404 shell and the dev server ship
// an empty #root, so fall back to a fresh client render there.
// firstElementChild (not firstChild) so the empty `<!--app-html-->` comment in
// the dev template / 404 shell doesn't count as prerendered content.
const container = document.getElementById("root")!;
if (container.firstElementChild) {
  hydrateRoot(container, <App />);
} else {
  createRoot(container).render(<App />);
}
